export default __webpack_public_path__ + "static/media/websitelogo.a24b3fff.png";